/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 16:07:41
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 10:58:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/ActivitiesTimeline/index.tsx
 */

import { Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  request_addCustomerComment,
  request_addSubscriberComment,
  request_deleteCustomerComment,
  request_deleteSubscriberComment,
} from '@/src/request/customer/customerDetail';
import { getParameter } from '@/src/tools/helper';
import { Timeline } from 'antd';
import _ from 'lodash';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import AddComment from '../../Components/AddComment';
import css from '../css.module.less';

const permissions = () => {
  const access_page_and_view_customer_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.access_page_and_view_customer_details_page,
      }),
    ],
  });
  const send_account_invite = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.send_account_invite,
      }),
    ],
  });
  const edit_customer_info = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.edit_customer_info,
      }),
    ],
  });
  const subscribe_customer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.subscribe_customer,
      }),
    ],
  });
  const delete_subscription = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.delete_subscription,
      }),
    ],
  });
  const erase_customer_data = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.erase_customer_data,
      }),
    ],
  });
  return {
    access_page_and_view_customer_details_page,
    send_account_invite,
    edit_customer_info,
    subscribe_customer,
    delete_subscription,
    erase_customer_data,
  };
};

const ActivitiesTimeline = ({
  setShowModal,
  setModalTitle,
  setModalContent,
  customerUuid,
  activities,
  reloadData,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { edit_customer_info, delete_subscription } = permissions();
  const parameterType = getParameter('type');
  const addComment = async (content) => {
    const req =
      parameterType == 'Subscriber'
        ? request_addSubscriberComment(customerUuid, { comment: content })
        : request_addCustomerComment({ customerUuid, comment: content });
    req.then(() => {
      reloadData(['TimeLine']);
      setShowModal(false);
    });
  };

  const deleteTimeLine = (id) => {
    const req =
      parameterType == 'Subscriber'
        ? request_deleteSubscriberComment(customerUuid, id)
        : request_deleteCustomerComment(customerUuid, id);
    req.then((data) => {
      reloadData(['TimeLine']);
    });
  };
  const handleAddComment = () => {
    setShowModal(true);
    setModalTitle(getI18n('customerList.activitiesTimeline.addComment'));

    setModalContent(
      <AddComment confirm={addComment} onCancel={() => setShowModal(false)} />,
    );
  };
  const activitiesList = (activities || []).map((activity) => ({
    ...activity,
    date: (activity.dateTime || '').split(' ')[0],
    time: (activity.dateTime || '').split(' ')[1],
  }));
  const formatActivitiesList = _.groupBy(activitiesList, 'date');

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.activitiesTimelineContainer} ${css.wrapperContainer}`}
        title={
          parameterType == 'Subscriber'
            ? getI18n(
                'customerList.activitiesTimeline.subscriberActivitiesTimeline',
              )
            : getI18n(
                'customerList.activitiesTimeline.accountActivitiesTimeline',
              )
        }>
        <div className={css.addCommentBtn}>
          <Button
            type='primary '
            onClick={handleAddComment}
            disabled={!edit_customer_info}>
            {getI18n('customerList.activitiesTimeline.addComment')}
          </Button>
        </div>
        <Timeline className={css.activityTimeline}>
          {Object.entries(formatActivitiesList).map((item, itemIndex) => (
            <Fragment key={itemIndex}>
              <Timeline.Item className={css.noTimelineItem} dot={<div></div>}>
                <span className={css.timelineTitle}>{item[0]}</span>
              </Timeline.Item>
              {item[1].map((list, listIndex) => (
                <Timeline.Item key={listIndex}>
                  <div>
                    {_.get(list, 'userName', '') &&
                      _.get(list, 'type', '') == 'Comment' && (
                        <div className={css.timelineTitle}>
                          {_.get(list, 'userName', '')}
                          {getI18n(
                            'customerList.activitiesTimeLine.leftacomment',
                          )}
                          :
                        </div>
                      )}
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: list.comment,
                        }}></div>
                    </div>
                    {_.get(list, 'type', '') == 'Comment' &&
                      delete_subscription && (
                        <div
                          className={css.timelineDelete}
                          onClick={() => deleteTimeLine(list.uuid)}>
                          {getI18n('general.delete')}
                        </div>
                      )}
                  </div>
                  <span>{list.time}</span>
                </Timeline.Item>
              ))}
            </Fragment>
          ))}
        </Timeline>
      </SectionWrapper>
    </div>
  );
};

export default ActivitiesTimeline;
